import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { VerifyEmailPage } from '@/pages/verify-email/verify-email-page';
import { safeAuthReturn } from '@/shared/lib/auth-return';

const VerifyEmailSearchSchema = z.object({
  token: z.string().min(8),
  next: z.unknown().transform((value) => safeAuthReturn(value)).optional(),
});

export const Route = createFileRoute('/verify-email')({
  component: VerifyEmailPage,
  validateSearch: VerifyEmailSearchSchema,
});
